import React, { useState } from 'react';
import { Seo, breadcrumbSchema, webPageSchema } from '../components/Seo';
import PageHeader from '../components/PageHeader';
import Tile from '../components/gallery/Tile';
import Lightbox from '../components/gallery/Lightbox';
import { GALLERY_IMAGES } from '../data/gallery';

const Gallery = () => {
  const [open, setOpen] = useState(null);

  return (
    <div data-testid="page-gallery">
      <Seo
        title="Photo Gallery · AdAura Awards 2026"
        description="Photographs from the AdAura Awards 2026 ceremony — 8th October 2026, Aerocity, New Delhi."
        path="/gallery"
        jsonLd={[
          webPageSchema({ path: '/gallery', name: 'Photo Gallery', description: 'AdAura Awards 2026 photo gallery — awards night, 8th October 2026.' }),
          breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Photo Gallery', path: '/gallery' }]),
        ]}
      />
      <PageHeader
        eyebrow="Awards Night"
        title="Photo Gallery"
        italicWords={['Gallery']}
      />

      <section className="pb-24 md:pb-32">
        <div className="content-container">
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5" data-testid="gallery-grid">
            {GALLERY_IMAGES.map((img, i) => (
              <Tile key={img.id} img={img} index={i} onOpen={setOpen} />
            ))}
          </div>
        </div>
      </section>

      {open !== null && (
        <Lightbox images={GALLERY_IMAGES} index={open} onClose={() => setOpen(null)} onIndex={setOpen} />
      )}
    </div>
  );
};

export default Gallery;
